module.exports = __webpack_public_path__ + "img/hsi_blue-logo-only.c9eb93bf.png";